<template>
  <main class="scroll">
    <div class="scroll-header" >
      <div class="scroll-conceal"></div>
      <div class="scroll-top" :style="{ backgroundPositionY: onAnimate ? 0 : calScrollPosition +'px' }">
        <div class="shadow"></div>
      </div>
    </div>
    <div
      class="scroll-view" ref="sView"
      :style="{ backgroundPositionY: '-'+ (onAnimate ? 0 : calScrollPosition) +'px', height: jzHeight}"
      @scroll="handleScroll"
    >
      <div class="scroll-content" role="main" >
        <slot></slot>
      </div>
    </div>
    <div class="scroll-footer" >
      <div class="scroll-bottom" :style="{ backgroundPositionY: calScrollPosition +'px' }">
        <div class="shadow"></div>
      </div>
      <div class="scroll-conceal"></div>
    </div>
  </main>
</template>
<script>
export default {
  data() {
    return {
      viewHeight: "", // 可见区域的样式
      scrollStyle: {}, // 卷轴的样式
      jzHeight: "5px", // 卷轴下偏移
      scrollPosition: 0,
      onAnimate: false
    };
  },
  props: {
    start: {
      type: Boolean,
      default: false, // 控制卷轴开始
    },
    showAll: {
      type: Boolean,
      default: true, // 控制卷轴显示样式，显示全部true还是显示部分false
    },
    speed: {
      type: String,
      default: "slow", // 卷轴打开速度 slow fast
    },
  },
  computed: {
    calScrollPosition: function () {
      return this.scrollPosition;
    },
  },
  methods: {
    handleScroll(e) {
      this.onAnimate = false;
      this.scrollPosition = e.srcElement.scrollTop;
    },
    handleStart() {
      this.onAnimate = true;
      let viewHeight = this.$refs.sView.clientHeight;
      let speed = 10;
      if (this.speed == "fast") {
        speed = 1;
      } else {
        speed = 10;
      }
      let time = setInterval(() => {
        viewHeight += 1;
        this.jzHeight = viewHeight + "px";
        // view样式渲染完成后执行卷轴的移动操作
        this.$nextTick(() => {
          this.scrollPosition = viewHeight;
        });
        if (viewHeight >= (this.$refs.sView.parentElement.clientHeight - 70 )) {
          clearInterval(time);
          if (!this.showAll) {
            let endPosition = 0;
            let endTime = setInterval(() => {
              endPosition += 0.5;
              // this.jzLeft = "-" + endPosition.toFixed(2) + "px";
              // this.jzRight = "-" + endPosition.toFixed(2) + "px";
              if (Math.abs(endPosition - 6) < 0.01) {
                clearInterval(endTime);
              }
            }, speed);
          }
        }
      }, speed);
    },
  },
  watch: {
    start: function (e) {
      if (e == true) {
        this.handleStart();
      }
    },
  },
};
</script>
<style>
main{
  margin: 0 10px;
}
.scroll {
  color: #000;
  margin: 1rem auto;
  position: relative;
  width: 100%;
  height: 100%;
}
.scroll .scroll-header {
  top: 0;
}
.scroll .scroll-footer {
  bottom: 0;
}
.scroll .scroll-header,
.scroll .scroll-footer {
  width: 100%;
  position: sticky;
  z-index: 1;
}
.scroll .scroll-top,
.scroll .scroll-bottom {
  background-image: url("./../assets/jz3.png");
  background-size: 100%;
  border-radius: 0.3em;
  height: 35px;
  z-index: 1;
}
.scroll .scroll-top .shadow {
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 15%,
    rgba(255, 255, 255, 0.6) 27%,
    rgba(255, 255, 255, 0.6) 30%,
    rgba(184, 184, 184, 0) 40%,
    rgba(0, 0, 0, 0.7) 66%,
    /* rgba(0, 0, 0, 0.57) 80%, */ rgba(255, 255, 255, 0.6) 85%,
    rgba(0, 0, 0, 0) 107%
  );
  height: 150%;
}
.scroll .scroll-footer .scroll-bottom {
  z-index: 2;
}
.scroll .scroll-footer .scroll-bottom .shadow {
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 6%,
    rgba(255, 255, 255, 0.6) 22%,
    rgba(255, 255, 255, 0.57) 25%,
    rgba(214, 214, 214, 0.45) 37%,
    rgba(170, 170, 170, 0) 50%,
    rgba(0, 0, 0, 0.7) 100%
  );
  border-radius: 0.3em;

  height: 100%;
}
.scroll {
  color: #000;
  margin: 1rem auto;
  position: sticky;
  width: 95%;
}
.scroll .scroll-view {
  background-image: url("./../assets/view-bg_compressed.jpg");
  background-repeat: repeat-y;
  background-size: 98%;
  background-position-x: center;
  margin: 0 auto;
  z-index: 0;
  max-height: 100%;
  overflow-y: scroll;
  width: 98%;
}
.scroll-content {
  max-height: 100%;
}
</style>